import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { GridView, ViewList } from "@mui/icons-material";

type DisplayModeTogglerType = {
  callback: Function;
};

const DisplayModeToggler: React.FunctionComponent<any> = (props): JSX.Element => {
  const { callback }: DisplayModeTogglerType = props;

  return (
    <Box id="sa_content_filtering-display_mode" display={{ xs: "none", sm: "block" }} pt={{ xs: 0 }} pb={{ xs: 0, sm: "0.25rem" }} textAlign="right">
      <IconButton sx={{ xs: { fontSize: "1rem" }, sm: { fontSize: "0.75rem" } }} aria-label="Visa träffar som rutnät" onClick={(e): void => callback("grid")}>
        <GridView fontSize="inherit" />
        <Typography variant="body1">Rutnätsvy</Typography>
      </IconButton>
      <IconButton sx={{ xs: { fontSize: "1rem" }, sm: { fontSize: "0.75rem" } }} aria-label="Visa träffar som lista" onClick={(e): void => callback("rows")}>
        <ViewList fontSize="inherit" /> <Typography variant="body1">Listvy</Typography>
      </IconButton>
    </Box>
  );
};

export default DisplayModeToggler;
